import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (globalAppConfig?.serviceClosed?.trim()) {
  renderServiceClosed(globalAppConfig.serviceClosed);
} else {
  if (environment.production) {
    enableProdMode();
  }
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

function renderServiceClosed(html: string) {
  const root = document.querySelector('app-root');
  if (!root) {
    return;
  }
  root.innerHTML = `
    <div style='max-width: 420px; margin:0 auto; padding: 24px 20px 40px;'>
      <div>${html}</div>
    </div>
  `;
}
